<div id="{{id}}" class="{{#if hideCriteriaFirstTime}}hidden{{/if}}">
    <field-item item="criteriaFormModel">
        <field-hcombo id="criteria-selectByType" name="type" label="" {options}="typeOptions"></field-hcombo>
        <uda-list of="recipients" name="recipients" label-key="recipients" class="inlineGroup" {visible}="states.recipients"></uda-list>
    </field-item>
</div>
